// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3JYnj","footer":"ModalUpdate_footer__Tp8lS"};